import { FC } from 'react'

import { TextPromo } from 'components/ui/TextPromo/TextPromo'
import { Title } from 'components/ui/Title/Title'
import { getAltFromSrc } from 'utils/helpers/getAltFromSrc/getAltFromSrc'
import { useResize } from 'utils/hooks/useResize'

import { statisticsData } from './data'

import s from './MarketPlaceStat.module.scss'

export const MarketPlaceStat: FC = () => {
  const { isSDesktop, isSTablet } = useResize()

  return (
    <section>
      <div className={`contentWrapper ${s.marketPlaceStatContainer}`}>
        <Title className={s.title} color="white" textAlign="center" fontWeight={isSTablet ? 550 : 700}>
          Станьте партнёром Wildberries — крупнейшего маркетплейса России и СНГ
        </Title>
        <div className={s.statisticsContent}>
          {statisticsData.map((item) => (
            <div className={s.statsItem} key={item.id}>
              <TextPromo
                className={s.statsValue}
                size={isSDesktop ? (isSTablet ? 's20' : 's24') : 's44'}
                weight="w700"
                color="white"
              >
                {item.value}
              </TextPromo>
              <TextPromo
                className={s.statsDescription}
                fontFamily="ASLHauss"
                size={isSDesktop ? (isSTablet ? 's16' : 's20') : 's20'}
                color="white"
              >
                {item.description}
              </TextPromo>
              <div className={s.statsIcon}>
                {item.IconLink ? <img src={item.IconLink} alt={getAltFromSrc(item.IconLink)} /> : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default MarketPlaceStat
